var map = {
	"./AL_svg.vue": "KEVv",
	"./BH_svg.vue": "xslT",
	"./BN_svg.vue": "A4uZ",
	"./HB_svg.vue": "sttV",
	"./KH_svg.vue": "fzkV",
	"./MS_svg.vue": "UcC0",
	"./UG_svg.vue": "8qOd",
	"./defaultChapterIcon_svg.vue": "ibqp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AsCW";


//////////////////
// WEBPACK FOOTER
// ./src/common/components/svg/chapter ^\.\/.*\.vue$
// module id = AsCW
// module chunks = 2